import { Color } from "../../theme";

export const ChartColorArray = [
  "brand",
  Color.gray8,
  Color.deepGray,
];
